export const similarProducts = [
  {
    id: 1,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/1.webp',
    title: 'Casio Watch',
    description: 'Casio Classic Watch',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
  {
    id: 2,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/2.webp',
    title: 'Beats Headphone',
    description: 'High Quality Wireless Headphone',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
  {
    id: 3,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/3.webp',
    title: 'Marc Jacob’s Decadent',
    description: 'Classic Marc Jacob’s Fragrance',
    price: 295.0,
    sale_price: 320.0,
    colors: [],
  },
  {
    id: 4,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/4.webp',
    title: 'Black Shoes',
    description: 'Classic Black Heels For Women',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
  {
    id: 5,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/5.webp',
    title: 'Casio Watch',
    description: 'Casio Classic Watch',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
  {
    id: 6,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/6.webp',
    title: 'Beats Headphone',
    description: 'High Quality Wireless Headphone',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
  {
    id: 7,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/7.webp',
    title: 'Marc Jacob’s Decadent',
    description: 'Classic Marc Jacob’s Fragrance',
    price: 295.0,
    sale_price: 320.0,
    colors: [],
  },
  {
    id: 8,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/8.webp',
    title: 'Black Shoes',
    description: 'Classic Black Heels For Women',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
  {
    id: 9,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/9.webp',
    title: 'Casio Watch',
    description: 'Casio Classic Watch',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
  {
    id: 10,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/10.webp',
    title: 'Beats Headphone',
    description: 'High Quality Wireless Headphone',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
];
